(function () {
  'use strict';

  const overlay = document.getElementById('popup-atc-overlay');
  const closeBtn = document.getElementById('popup-atc-close');

  if (!overlay) return;

  // Modifica 10/10/2026: su smartphone il popup non si apre (copriva il carrello laterale e il Check-out)
  const isMobile = window.matchMedia('(max-width: 767px)');

  function openPopup() {
    if (isMobile.matches) return;
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('popup-atc-open');
    closeBtn && closeBtn.focus();
    document.dispatchEvent(new CustomEvent('popup:atc:open', { detail: { overlay } }));
  }

  function closePopup() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('popup-atc-open');
    document.dispatchEvent(new CustomEvent('popup:atc:close'));
  }

  function bindForms() {
    const forms = document.querySelectorAll('form[action="/cart/add"]');

    forms.forEach(function (form) {
      if (form.dataset.popupBound) return;
      form.dataset.popupBound = 'true';

      const submitBtn = form.querySelector('[type="submit"]');
      if (!submitBtn) return;

      submitBtn.addEventListener('click', function (e) {
        // NON blocchiamo il comportamento nativo del tema
        // Il tema aggiungerà al carrello come fa normalmente

        // Aspettiamo un momento che il tema completi la sua logica,
        // poi apriamo il popup
        setTimeout(openPopup, 300);
      });
    });
  }

  // Chiudi con X
  closeBtn && closeBtn.addEventListener('click', closePopup);

  // Chiudi cliccando fuori
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closePopup();
  });

  // Chiudi con ESC
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) closePopup();
  });

  // Init
  bindForms();

  // Supporto sezioni dinamiche Shopify
  document.addEventListener('shopify:section:load', bindForms);

})();